import { render } from "./Statistics.vue?vue&type=template&id=0ccbb896&ts=true"
import script from "./Statistics.vue?vue&type=script&lang=ts"
export * from "./Statistics.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__